.textField {
  margin-top: 16px;
  margin-bottom: 16px;
}

.message {
  margin-top: 16px;
  margin-bottom: 16px;
}

.buttonGroup {
  width: 100%;
}
